<template>
    <div class="top-banner">
      <div class="banner">
        <span class="banner-title">首页</span>
        <template v-for="(item,index) in list">
            <span :key="'arrow'+index" class="el-icon-arrow-right"></span>
            <span :key="'headtitle'+index" class="banner-title">{{item}}</span>
        </template>
      </div>
    </div>
</template>

<script>
export default {
    props:{
        list:{
            type:Array
        }
    }
}
</script>

<style scoped>
.top-banner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fafafa;
    height: 50px;
    box-sizing: border-box;
    padding: 0 220px;
    color: #7f7f80;
    font-size: 18px;
    line-height: 50px;
    white-space: nowrap;
    display: none;
}
.el-icon-arrow-right{
    margin: 0 25px;
}
</style>